export default __webpack_public_path__ + "static/media/img_15.83cf8b2e.JPG";